import React from 'react';
import Page from 'src/components/Page';
import { Conversations } from '../components';

export const ConversationsView = () => {
    return (
        <Page title={'Conversaciones'}>
            <Conversations />
        </Page>
    );
};
